import { shallowRef } from 'vue'

export type MobilePageMenuItem = {
  id: string
  label: string
  icon?: any
  badge?: string | number
  active?: boolean
  action: () => unknown | Promise<unknown>
}

export type MobilePageMenuSection = {
  id: string
  label: string
  items: MobilePageMenuItem[]
}

export type MobilePageMenuConfig = {
  sections: MobilePageMenuSection[]
  actions: MobilePageMenuItem[]
}

const mobilePageMenuState = shallowRef<MobilePageMenuConfig>({
  sections: [],
  actions: [],
})

export function useMobilePageMenu() {
  return mobilePageMenuState
}

export function resetMobilePageMenu() {
  mobilePageMenuState.value = {
    sections: [],
    actions: [],
  }
}
